<template>
  <div>
    <!-- 기본 -->
    <basic-oneto-one-all v-if="!isLaunchpack"></basic-oneto-one-all>

    <!-- 마스터 백오피스 -->
    <launchpack-oneto-one-all v-if="isLaunchpack"></launchpack-oneto-one-all>
  </div>
</template>

<script>



  import BasicOnetoOneAll from "./BasicOnetoOneAll";
  import LaunchpackOnetoOneAll from "./LaunchpackOnetoOneAll";

  export default {
    name: 'OnetoOneAll',
    layout: 'Main',
    components: {
      LaunchpackOnetoOneAll,
      BasicOnetoOneAll

    },
    data() {
      return {
      }
    },
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
